/**
 * Process dropped items from drag and drop
 * @param {DataTransferItemList} items - Drop items
 * @returns {Promise<Array>} - Array of file objects with path and fileRef
 */
export const processDroppedItems = async (items) => {
  const allFiles = [];

  const readEntry = async (entry, path = '') => {
    if (entry.isFile) {
      const file = await new Promise((resolve) => entry.file(resolve));
      allFiles.push({
        path: path + file.name,
        name: file.name,
        type: 'blob',
        fileRef: file
      });
    } else if (entry.isDirectory) {
      const reader = entry.createReader();
      const entries = await new Promise((resolve) => reader.readEntries(resolve));
      for (const child of entries) {
        await readEntry(child, path + entry.name + '/');
      }
    }
  };

  for (const item of items) {
    const entry = item.webkitGetAsEntry();
    if (entry) await readEntry(entry);
  }

  return allFiles;
};

/**
 * Process uploaded files from file input
 * @param {FileList} filesList - Files from input element
 * @returns {Array} - Array of file objects with path and fileRef
 */
export const processUploadedFiles = (filesList) => {
  return Array.from(filesList).map(file => ({
    path: file.webkitRelativePath,
    name: file.name,
    type: 'blob',
    fileRef: file
  }));
};
